<template>
  <div>
    <v-list two-line>
      <template v-for="(message, index) of messages">
        <v-list-item :key="message.id" avatar class="message-list-item">
          <v-list-item-avatar :color="message.company_id === null ? 'primary' : 'grey'" style="height: 40px !important">
            <h3 class="white--text" style="top: 1px; position: relative;">{{ message.created_by_name.charAt(0) }}</h3>
          </v-list-item-avatar>
          <v-list-item-content style="height: auto; text-justify: auto">
            <v-list-item-title>
              <v-row no-gutters>
                <span class="align-content-end headline mt-2 mr-5">
                  {{ message.created_by_name }} <span class="date-style">{{ message.created_at }}</span>
                </span>
                <travel-service-order-item-chip
                  v-if="typeof message.orderItem !== 'undefined' && message.orderItem.id !== travelServiceOrderItemId"
                  :travel-service-order-item="message.orderItem"
                  :click-url="$store.getters['companyContext'] === null ? '/admin/travel-service/item/readonly/' : '/travel-service/item-details/'"
                  :new-tab="true"
                />
              </v-row>
            </v-list-item-title>
            <v-list-item-subtitle class="message-list-subtitle">
              {{ message.message }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider :inset="true" :key="-index" v-if="index !== messages.length - 1" />
      </template>
    </v-list>

    <v-row class="pl-1" no-gutters>
      <v-avatar class="ma-2" color="accent">
        <v-icon color="white">fa-plus</v-icon>
      </v-avatar>
      <v-textarea v-model="content" auto-grow full-width hide-details outlined :placeholder="$t('global.messageContent')" />
    </v-row>
    <v-row class="pl-1" no-gutters>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-avatar v-on="on" class="mx-2" :color="!showAll ? 'grey' : 'primary'" @click="showAll = !showAll" style="position: relative; top: -4px;">
            <v-icon color="white">fa-project-diagram</v-icon>
          </v-avatar>
        </template>
        <span v-if="!showAll">{{ $t("global.showMessagesFromLinkedOrders") }}</span>
        <span v-if="showAll">{{ $t("global.showMessagesOnlyFromThisOrder") }}</span>
      </v-tooltip>
      <v-row class="px-3 py-1">
        <v-btn :disabled="$store.getters['Ajax/loading']" @click="send()" color="accent" style="width: 100%">
          {{ $t("global.sendMessage") }}
        </v-btn>
      </v-row>
    </v-row>
  </div>
</template>

<script>
import TravelServiceOrderItemChip from "./TravelService/Chips/TravelServiceOrderItemChip";
export default {
  name: "MessageList",
  components: { TravelServiceOrderItemChip },
  props: {
    travelServiceOrderId: {
      default: null,
      required: true
    },
    travelServiceOrderItemId: {
      default: null,
      required: false
    },
    startMessages: {
      default: null,
      required: false
    }
  },
  watch: {
    showAll() {
      this.downloadMessages();
    }
  },
  data: () => ({
    content: null,
    showAll: false,
    messages: []
  }),
  created() {
    if (this.startMessages === null) {
      this.downloadMessages();
    } else {
      this.messages = this.startMessages;
    }
  },
  methods: {
    send() {
      // this.$emit("send", this.content);
      // this.content = null;
      this.axios
        .post("travel-service/save-new-message", {
          travel_service_order_item_id: this.travelServiceOrderItemId,
          travel_service_order_id: this.travelServiceOrderId,
          message: this.content
        })
        .then(() => {
          this.content = null;
          this.downloadMessages();
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved"),
            position: "down"
          });
        });
    },
    downloadMessages() {
      let action = "get-messages";
      if (this.showAll) {
        action = "get-linked-messages";
      }
      this.axios
        .get("travel-service/" + action, {
          params: { travel_service_order_id: this.travelServiceOrderId, travel_service_order_item_id: this.travelServiceOrderItemId }
        })
        .then(resp => {
          this.messages = resp.data;
        });
    }
  }
};
</script>

<style>
.date-style {
  font-size: small;
  color: #909194;
}
.message-list-item > div {
  height: auto !important;
  text-wrap: normal;
}
.message-list-subtitle {
  white-space: normal;
  text-align: justify;
}
</style>
